<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faList, faTable } from '@fortawesome/pro-solid-svg-icons'
import { PendoFeature } from '~/models/Pendo'

const props = defineProps<{
  modelValue: 'rows' | 'table'
}>()

const emit = defineEmits<{
  'update:modelValue': [value: 'rows' | 'table']
}>()

function updateMode(mode: 'rows' | 'table') {
  emit('update:modelValue', mode)
}
</script>

<template>
  <div class="flex gap-2 mr-2">
    <button
      type="button"
      class="border-green-40 flex items-center gap-2 rounded-lg border p-2 text-sm font-medium transition focus-visible:ring sm:p-3"
      :class="props.modelValue === 'rows'
        ? 'bg-green-40 text-white'
        : 'bg-white text-green-40 hover:bg-green-40/10'"
      :data-pendo="PendoFeature.ActivityReports.ListMode"
      @click="updateMode('rows')"
    >
      <FontAwesomeIcon :icon="faList" class="h-4 w-4 sm:h-5 sm:w-5" />
    </button>
    <button
      type="button"
      class="border-green-40 flex items-center gap-2 rounded-lg border p-2 text-sm font-medium transition focus-visible:ring sm:p-3"
      :class="props.modelValue === 'table'
        ? 'bg-green-40 text-white'
        : 'bg-white text-green-40 hover:bg-green-40/10'"
      :data-pendo="PendoFeature.ActivityReports.TableMode"
      @click="updateMode('table')"
    >
      <FontAwesomeIcon :icon="faTable" class="h-4 w-4 sm:h-5 sm:w-5" />
    </button>
  </div>
</template>
